 /*============ Static Masthead Controller
  ================================*/
  angular.module("vppApp").controller("staticMastheadController", staticMastheadController);

  staticMastheadController.$inject = [
    "$scope",
    "staticMastheadFactory", '$element', '$attrs'
  ];
 
  function staticMastheadController($scope, staticMastheadFactory, $element, $attrs) {
 
    staticMastheadFactory().then(function(response) {
      var data = response.data.content;
      $scope.items = data;
      console.log($scope.items, "scope")
      // console.log('hello')
 
    });
  }
 